
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-burger]');
  if(b){var m=document.getElementById('MobileNav');if(m){var o=m.classList.toggle('open');b.setAttribute('aria-expanded',o);}}
});
document.addEventListener('click',function(e){
  var s=e.target.closest('[data-qty]');
  if(!s)return;
  var wrap=s.closest('.qty');var input=wrap.querySelector('input');
  var v=parseInt(input.value||'1',10);
  input.value=Math.max(1, s.dataset.qty==='up'?v+1:v-1);
});
(function(){
  var y=document.getElementById('yr'); if(y) y.textContent=new Date().getFullYear();
})();
(function(){
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var track=g.querySelector('[data-g-track]'); if(!track) return;
    var slides=track.children;
    var thumbs=g.querySelectorAll('.g-thumb');
    var prev=g.querySelector('[data-g-prev]');
    var next=g.querySelector('[data-g-next]');
    function idx(){ return Math.round(track.scrollLeft/track.clientWidth); }
    function go(i){ i=Math.max(0,Math.min(slides.length-1,i)); track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
    if(prev) prev.addEventListener('click',function(){ go(idx()-1); });
    if(next) next.addEventListener('click',function(){ go(idx()+1); });
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ go(parseInt(t.dataset.gI,10)); }); });
    function sync(){ var c=idx(); thumbs.forEach(function(t,i){ t.classList.toggle('is-active',i===c); }); }
    var raf; track.addEventListener('scroll',function(){ if(raf) cancelAnimationFrame(raf); raf=requestAnimationFrame(sync); });
  });
})();
